class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.initializeSlider();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  initializeSlider() {
    const slider = document.querySelector('.cart-maison-style-slider');
    const prevButton = document.querySelector('.cart-maison-prev-btn');
    const nextButton = document.querySelector('.cart-maison-next-btn');
    const products = document.querySelectorAll('.cart-maison-style-product');
    let currentIndex = 0;

    if (!slider || !prevButton || !nextButton || products.length === 0) return;

    function slideToIndex(index) {
      if (index < 0 || index >= products.length) return;
      
      currentIndex = index;
      const sliderWidth = slider.clientWidth;
      slider.style.transform = `translateX(-${sliderWidth * index}px)`;
    }

    // Remove existing listeners before adding new ones
    prevButton.replaceWith(prevButton.cloneNode(true));
    nextButton.replaceWith(nextButton.cloneNode(true));

    // Get fresh references after cloning
    const newPrevButton = document.querySelector('.cart-maison-prev-btn');
    const newNextButton = document.querySelector('.cart-maison-next-btn');

    newPrevButton.addEventListener('click', () => {
      if (currentIndex > 0) {
        slideToIndex(currentIndex - 1);
      }
    });

    newNextButton.addEventListener('click', () => {
      if (currentIndex < products.length - 1) {
        slideToIndex(currentIndex + 1);
      }
    });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Custom JS

document.addEventListener('submit', function(e) {
  const form = e.target;
  
  // Check if this is our upsell form
  if (!form.classList.contains('cart-maison-product-form')) return;
  
  e.preventDefault();
  
  const submitButton = form.querySelector('.cart-maison-add-to-cart-btn');
  submitButton.classList.add('loading');
  submitButton.disabled = true;
  
  const formData = new FormData(form);
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(() => {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 
        updates: {}, 
        sections: ["cart-drawer", "cart-icon-bubble"] 
      }),
    });
  })
  .then((res) => res.json())
  .then((cart) => {
    document.querySelector("cart-drawer").renderContents(cart);
    document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    submitButton.classList.remove('loading');
    submitButton.disabled = false;
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.cart-maison-style-slider');
  const prevButton = document.querySelector('.cart-maison-prev-btn');
  const nextButton = document.querySelector('.cart-maison-next-btn');
  const products = document.querySelectorAll('.cart-maison-style-product');
  let currentIndex = 0;

  if (!slider || !prevButton || !nextButton || products.length === 0) return;

  function slideToIndex(index) {
    if (index < 0 || index >= products.length) return;
    
    currentIndex = index;
    const sliderWidth = slider.clientWidth;
    slider.style.transform = `translateX(-${sliderWidth * index}px)`;
  }

  prevButton.addEventListener('click', () => {
    if (currentIndex > 0) {
      slideToIndex(currentIndex - 1);
    }
  });

  nextButton.addEventListener('click', () => {
    if (currentIndex < products.length - 1) {
      slideToIndex(currentIndex + 1);
    }
  });

  // Optional: Add touch/swipe support
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    const difference = touchStartX - touchEndX;
    
    if (Math.abs(difference) < 30) return; // Minimum swipe distance

    if (difference > 0 && currentIndex < products.length - 1) {
      // Swipe left
      slideToIndex(currentIndex + 1);
    } else if (difference < 0 && currentIndex > 0) {
      // Swipe right
      slideToIndex(currentIndex - 1);
    }
  });
});

// Flag script
(() => {
    let storedCountryInfo = null; // Variable to store country info

    const countryFlags = {
        'US': '🇺🇸',
        'CA': '🇨🇦',
        'FR': '🇫🇷',
        'NL': '🇳🇱',
        'DE': '🇩🇪',
        'GB': '🇬🇧',
        'IT': '🇮🇹',
        'ES': '🇪🇸',
        'CN': '🇨🇳',
        'JP': '🇯🇵',
        'BR': '🇧🇷',
        'IN': '🇮🇳',
        'RU': '🇷🇺',
        'ZA': '🇿🇦',
        'AU': '🇦🇺',
        'NZ': '🇳🇿',
        'MX': '🇲🇽',
        'AR': '🇦🇷',
        'CL': '🇨🇱',
        'CO': '🇨🇴',
        'PE': '🇵🇪',
        'VE': '🇻🇪',
        'EC': '🇪🇨',
        'GT': '🇬🇹',
        'HN': '🇭🇳',
        'SA': '🇸🇦',
        'AE': '🇦🇪',
        'TR': '🇹🇷',
        'TH': '🇹🇭',
        'MY': '🇲🇾',
        'SG': '🇸🇬',
        'ID': '🇮🇩',
        'PH': '🇵🇭',
        'VN': '🇻🇳',
        'KR': '🇰🇷',
        'KP': '🇰🇵',
        'SE': '🇸🇪',
        'NO': '🇳🇴',
        'FI': '🇫🇮',
        'DK': '🇩🇰',
        'IS': '🇮🇸',
        'IE': '🇮🇪',
        'CH': '🇨🇭',
        'PT': '🇵🇹',
        'BE': '🇧🇪',
        'LU': '🇱🇺',
        'PL': '🇵🇱',
        'CZ': '🇨🇿',
        'SK': '🇸🇰',
        'HU': '🇭🇺',
        'AT': '🇦🇹',
        'LI': '🇱🇮',
        'GR': '🇬🇷',
        'BG': '🇧🇬',
        'RO': '🇷🇴',
        'UA': '🇺🇦',
        'BY': '🇧🇾',
        'LT': '🇱🇹',
        'LV': '🇱🇻',
        'EE': '🇪🇪',
        'MD': '🇲🇩',
        'AM': '🇦🇲',
        'GE': '🇬🇪',
        'AZ': '🇦🇿',
        'IR': '🇮🇷',
        'IQ': '🇮🇶',
        'SY': '🇸🇾',
        'LB': '🇱🇧',
        'JO': '🇯🇴',
        'IL': '🇮🇱',
        'EG': '🇪🇬',
        'MA': '🇲🇦',
        'DZ': '🇩🇿',
        'TN': '🇹🇳',
        'LY': '🇱🇾',
        'GM': '🇬🇲',
        'SN': '🇸🇳',
        'MR': '🇲🇷',
        'ML': '🇲🇱',
        'GN': '🇬🇳',
        'CI': '🇨🇮',
        'BF': '🇧🇫',
        'NE': '🇳🇪',
        'TG': '🇹🇬',
        'BJ': '🇧🇯',
        'NG': '🇳🇬',
        'CM': '🇨🇲',
        'GA': '🇬🇦',
        'CG': '🇨🇬',
        'CD': '🇨🇩',
        'AO': '🇦🇴',
        'GW': '🇬🇼',
        'SC': '🇸🇨',
        'SD': '🇸🇩',
        'RW': '🇷🇼',
        'ET': '🇪🇹',
        'SO': '🇸🇴',
        'DJ': '🇩🇯',
        'KE': '🇰🇪',
        'TZ': '🇹🇿',
        'UG': '🇺🇬',
        'BI': '🇧🇮',
        'MZ': '🇲🇿',
        'ZM': '🇿🇲',
        'MW': '🇲🇼',
        'LS': '🇱🇸',
        'BW': '🇧🇼',
        'NA': '🇳🇦',
        'ZA': '🇿🇦',
        'SZ': '🇸🇿',
        'HK': '🇭🇰',
        'PK': '🇵🇰'
        // Add more country code mappings here
    };
    
    function setLocationInfo(countryCode, countryName) {
        const flagEmoji = countryFlags[countryCode];
        const locationInfoP = document.getElementById('locationinfop');
        const locationInfoCart = document.getElementById('locationinfocart');
    
        const shippingMessage = flagEmoji
            ? `<span>${countryCode} ${flagEmoji}</span>`
            : `<span>${countryCode}</span>`;
    
        const shippingMessageCart = flagEmoji
            ? `to ${flagEmoji} ${countryCode}`
            : `to ${countryCode}`;
    
        if (locationInfoP) {
            locationInfoP.innerHTML = shippingMessage;
        }
        if (locationInfoCart) {
            locationInfoCart.innerHTML = shippingMessageCart;
        }
    }
    
    function updateLocationDisplay() {
        if (storedCountryInfo) {
            setLocationInfo(storedCountryInfo.countryCode, storedCountryInfo.countryName);
        }
    }

    function setupCartObserver() {
        const cartDrawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
        if (!cartDrawer) {
            console.error('Cart drawer element not found');
            return;
        }
        
        const observer = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                // Only trigger if the location info elements are actually affected
                const locationElements = ['locationinfop', 'locationinfocart'];
                const affectedElements = Array.from(mutation.addedNodes)
                    .filter(node => node.nodeType === 1)
                    .some(element => {
                        return locationElements.some(id => 
                            element.id === id || element.querySelector(`#${id}`)
                        );
                    });

                if (affectedElements) {
                    updateLocationDisplay(); // Use stored info instead of making API call
                    break;
                }
            }
        });

        observer.observe(cartDrawer, { 
            childList: true, 
            subtree: true,
            characterData: false,
            attributes: false
        });
    }

    // Initialize - only fetch location once
    function initializeLocation() {
        fetch('/browsing_context_suggestions.json')
            .then(response => response.json())
            .then(data => {
                storedCountryInfo = {
                    countryCode: data.detected_values.country.handle,
                    countryName: data.detected_values.country.name
                };
                updateLocationDisplay();
                setupCartObserver();
            })
            .catch(error => console.error('Error fetching location info:', error));
    }

    // Initialize on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeLocation);
    } else {
        initializeLocation();
    }
})();